import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import GameFlowEvent from "../core/controller/GameFlowEvent";
import GameConfig from "../core/model/GameConfig";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";
import ProgressDotsView from "./ProgressDotsView";

export default class TutorialScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
    }

    initialize() {
        super.initialize();

        // initialize example scenario
        this._target.npcBalloon.bodyTextfield.text = this.getText("tutorial.example.npcSpeech");

        let yPosition = this._target.tutorialDialogPanel.dialogOptionButton1.y + this._target.tutorialDialogPanel.dialogOptionButton1.getBounds().height;
        for (let i = 1; i <= 3; i++) {
            const button = this.createSlice9Button(this._target.tutorialDialogPanel[`dialogOptionButton${i}`], null, this.getText(`tutorial.example.option${i}`));
            button.skin.y = yPosition - button.getBounds().height;
            yPosition = button.skin.y - 10;
        }

        this.anchorObject(this._target.npcBalloon, Anchor.T);
        this.anchorObject(this._target.tutorialDialogPanel, Anchor.B);

        // initialize tutorial overlays

        this._bgs = [];
        // this._lines = [];
        let i;
        for (i = 0; i < 99; i++) {
            const assetIndex = i + 1;
            const bg = this._target["bg" + assetIndex];
            if (!bg) {
                break;
            }
            this._bgs.push(bg);
            // block clicks through panel, quick and dirty
            bg.addEventListener("click", () => { });
            // anchoring
            this.unanchorObject(bg, true);
            const anchorStr = this._gameConfig.getValue("tutorial.anchoring")[i];
            this.anchorObject(bg, anchorStr ? Anchor[anchorStr] : Anchor.C);

            // const lines = this._target["lines" + assetIndex];
            // this._lines.push(lines);
            // this.anchorObject(lines, Anchor.T);
        }
        this._numPages = i;

        this.anchorObject(this._target.progressDots, Anchor.B);
        this.anchorObject(this._target.nextButton, Anchor.B);
        this.anchorObject(this._target.prevButton, Anchor.B);
        this.anchorObject(this._target.button, Anchor.B);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
        this.anchorObject(this._target.titleTextfield, Anchor.T);

        this._progressView = new ProgressDotsView(this._target.progressDots, i);

        this._buttonNext = this.createButton(this._target.nextButton, this._handleNext.bind(this), this.getText("tutorial.buttonNext"));
        this._buttonPrev = this.createButton(this._target.prevButton, this._handlePrev.bind(this), this.getText("tutorial.buttonPrev"));
        this._buttonStart = this.createButton(this._target.button, this._handleStart.bind(this), this.getText("tutorial.buttonStart"));

        this._fadeIn();

        // NB: add all tutorial overlay components into a container so they can all be faded in together
        this._tutorialContainer = new createjs.Container();
        this._target.addChild(this._tutorialContainer);
        this._tutorialContainer.addChild(... this._bgs, this._target.progressDots, this._target.nextButton, this._target.prevButton, this._target.button, this._target.bodyTextfield, this._target.titleTextfield);
        this._tutorialContainer.alpha = 0;
        this.callDelayed(() => {
            createjs.Tween.get(this._tutorialContainer).to({ alpha: 1 }, this._gameConfig.getValue("tutorial.fadeDuration"), createjs.Ease.cubicOut);
            this._setPage(0);
        }, this._gameConfig.getValue("tutorial.delay"));
    }

    destroy() {
        super.destroy();
    }

    _handleNext() {
        this._changePage(1);
    }

    _handlePrev() {
        this._changePage(-1);
    }

    _handleStart() {
        this._buttonPrev.setEnabled(false);
        this._buttonNext.setEnabled(false);
        this._buttonStart.setEnabled(false);
        this.dispatch(GameFlowEvent.TUTORIAL_COMPLETED);
    }


    _changePage(delta) {
        const numPages = this._numPages;
        // NB: clamp index between 0 and the number of pages
        const index = Math.min(Math.max(0, this._currentPageIndex + delta), numPages - 1);
        this._target.gotoAndStop(index);
        const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
        const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
        createjs.Tween.get(this._target)
            .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
            .call(() => {
                this._setPage(index);
            })
            .wait(wait)
            .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
    }

    _setPage(index) {
        this._currentPageIndex = index;
        const numPages = this._numPages;
        this._buttonPrev.setEnabled(index > 0);
        this._buttonNext.setEnabled(index < numPages - 1);
        this._buttonNext.setVisible(index < numPages - 1);
        this._buttonStart.setVisible(index >= numPages - 1);
        this._progressView.setProgress(index);

        const prefix = `tutorial.overlay${index + 1}`;
        this._target.bodyTextfield.text = this.getText(prefix + ".body");
        this._target.titleTextfield.text = this.getText(prefix + ".title");

        this._bgs.forEach((bg, i) => { bg.visible = i == index; });
        // this._lines.forEach((lines, i) => { lines.visible = i == idx; });
    }
};